export const scenesData = [
  {
    id: 0,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Main-Intrance.mp4",
    title: "Reception Desk",
    rotation: [0, 80, 0],
    next: 1,
    hotspots: [
      {
        id: "to-workzone",
        position: [-4.8, -2, -2.75],
        iconRotation: -20,
        type: "navigate",
        target: 1,
      },
    ],
  },
  {
    id: 1,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Inside-Office.mp4",
    title: "Entrance",
    rotation: [15, 80, 0],
    next:2,
    hotspots: [
      {
        id: "inside-vision-room",
        position: [0.1, -0.8, -1],
        iconRotation: -5,
        type: "navigate",
        target: 2,
      },
      {
        id: "left-entry",
        position: [-5, -3, 0.5],
        iconRotation: -5,
        type: "navigate",
        target: 4,
      },
    ],
  },
  {
    id: 2,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Inside-Vision-Room.mp4",
    title: "Vision Room",
    next: 4,
    rotation: [0, 95, 0],
    hotspots: [
      {
        id: "to-workzone",
        position: [0.5, -0.35, -0.18],
        iconRotation: 10,
        type: "navigate",
        target: 1,
      }
    ],
  },
  {
    id: 3,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Entry-To-The-Office.mp4",
    title: "Robot Zone",
    rotation: [5, 50, 0],
    hotspots: [
      {
        id: "towards-tought-room",
        position: [-1, -0.9, 1.42],
        iconRotation: 60,
        type: "navigate",
        target: 4,
      },
      {
        id: "head-towards-clarity-room",
        position: [-0.1, -2, -2.8],
        iconRotation: -5,
        type: "navigate",
        target: 6,
      },
    ],
  },
  {
    id: 4,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Entry-To-The-Office.mp4",
    title: "Robot Zone",
    next: 24,
    rotation: [10, 85, 0],
    hotspots: [
      {
        id: "towards-left",
        position: [-1.5, -1.6, 2.5],
        iconRotation: 55,
        type: "navigate",
        target: 24,
      },
      {
        id: "inside-the-thought",
        position: [0.6, -1.5, 2],
        iconRotation: -90,
        type: "navigate",
        target: 5,
      },
      {
        id: "towards-right-side",
        position: [-1.2, -0.75, -2],
        iconRotation: 5,
        type: "navigate",
        target: 6,
      },
      {
        id: "go-outside",
        position: [4, -1, -0.2],
        iconRotation: 5,
        type: "navigate",
        target: 0,
      },

       {
        id: "inside-clarity",
        position: [0.1, -0.7, -4],
        iconRotation: 5,
        type: "navigate",
        target: 8,
      },
       {
        id: "towards-corridor",
        position: [-0.5, -0.7, -4],
        iconRotation: 5,
        type: "navigate",
        target: 7,
      },
    ],
  },
 
  {
    id: 5,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Thought-Room.mp4",
    title: "Meeting Room - Thought",
    rotation: [5, 90, 0],
    next: 6,
    hotspots: [
      {
        id: "towards-electronics",
        position: [1.5, -3, 2],
        type: "navigate",
        target: 4,
      },
    ],
  },
  
  {
    id: 6,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Towards-Clarity.mp4",
    title: "Robot Zone",
    rotation: [0, 25, 0],
    next: 8,
    hotspots: [
      {
        id: "towards-electronics",
        position: [-0.05, -0.3, -1],
        iconRotation: -5,
        type: "navigate",
        target: 7,
      },
      {
        id: "inside-clarity",
        position: [0.5, -0.49, -1.4],
        iconRotation: 70,
        type: "navigate",
        target: 8,
      },
      {
        id: "to-center-of-office",
        position: [-2.5, -1.5, -0.55],
        iconRotation: -10,
        type: "navigate",
        target: 23,
      },
      {
        id: "inside-though",
        position: [2.25, -1.7, 7],
        iconRotation: -60,
        type: "navigate",
        target: 5,
      },
      {
        id: "Left side",
        position: [0.5, -1.75, 6],
        iconRotation: 60,
        type: "navigate",
        target: 24,
      },
      
    ],
  },

   {
    id: 7,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Lab-Corridor.mp4",
    title: "Lab Corridor",
    rotation: [0, -25, 0],
    isFlag: true,
    next: 9,
    hotspots: [
      {
        id: "inside-electronics",
        position: [1.3, -1.25, -2],
        iconRotation: 15,
        type: "navigate",
        target: 9,
      },
      {
        id: "inside-mechanical",
        position: [4.2, -1, 2],
        iconRotation: 15,
        type: "navigate",
        target: 10,
      },
      {
        id: "inside-pantry",
        position: [-0.2, -0.4, -1.1],
        iconRotation: 50,
        type: "navigate",
        target: 11,
      },
      {
        id: "towards-ephiphony",
        position: [-0.55, -0.3, -0.8],
        iconRotation: -10,
        type: "navigate",
        target: 13,
      },

       {
        id: "back-to-workstation2",
        position: [-1.8, -1.4, 2.5],
        iconRotation: 0,
        type: "navigate",
        target: 6,
      },
      {
        id: "back-to-workstation2",
        position: [0.5, -1.5, 2.5],
        iconRotation: -25,
        type: "navigate",
        target: 8,
      },
    ],
  },
  
  {
    id: 8,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Inside-Clarity.mp4",
    title: "Meeting Room - Clarity",
    rotation: [10, 90, 0],
    next: 7,
    hotspots: [
      {
        id: "to-electronics",
        position: [2, -2.5, 1.8],
        iconRotation: -50,
        type: "navigate",
        target: 7,
      },
    ],
  },
  {
    id: 9,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Electronics-Lab.mp4",
    title: "Electronics Lab",
    rotation: [15, -90, 0],
    next: 10,
    hotspots: [
      {
        id: "inside-mechanical-lab",
        position: [-1.45, -0.4, -1.1],
        iconRotation: -40,
        type: "navigate",
        target: 10,
      },
      {
        id: "to-outside-electronics-lab",
        position: [0.4, -0.8, -2],
        iconRotation: 65,
        type: "navigate",
        target: 7,
      },
    ],
  },
  {
    id: 10,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Mechanical-Lab.mp4",
    title: "Mechanical Lab",
    rotation: [40, 100, 0],
    next: 11,
    hotspots: [
      {
        id: "step-out-infront-electronics",
        position: [0.65, -2, 2.5],
        type: "navigate",
        target: 7,
      },
    ],
  },


  {
    id: 11,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Pantry.mp4",
    title: "Refreshment Lobby",
    rotation: [20, 50, 0],
    next: 12,
    hotspots: [
      {
        id: "inside-back-office",
        position: [4, -1.1, -0.05],
        iconRotation: 90,
        type: "navigate",
        target: 13,
      },
    ],
  },
  {
    id: 12,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Epiphany-Room.mp4",
    title: "Meeting Room - Epiphany",
    rotation: [0, 100, 0],
    next: 13,
    hotspots: [
      {
        id: "inside-back-office",
        position: [1, -1.8, 3.4],
        type: "navigate",
        target: 13,
      },
    ],
  },
  {
    id: 13,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Towardes-Back-Office.mp4",
    title: "Lab Corridor",
    rotation: [0, 50, 0],
    next: 14,
    hotspots: [
      {
        id: "inside-epiphany",
        position: [1.5, -2, -2],
        iconRotation: -20,
        type: "navigate",
        target: 12,
      },
      {
        id: "inside-back-office",
        position: [-2, -0.4, 0], 
        iconRotation: -5,
        type: "navigate",
        target:15,
      },
      {
        id: "inside-enlightment",
        position: [-7.75, -2, -0.4], 
        iconRotation: 80,
        type: "navigate",
        target:14,
      },
      {
        id: "back-to-electronic-frontside",
        position: [3, -1, -0.25], 
        iconRotation: -10,
        type: "navigate",
        target: 7,
      },
      {
        id: "towards-center-of-office",
        position: [-4, -1.4, 1.35], 
        iconRotation: -70,
        type: "navigate",
        target:16,
      },
    ],
  },

  {
    id: 14,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Enlightenment.mp4",
    title: "Meeting Room - Enlightenment",
    rotation: [15, 95, 0],
    next: 15,
    hotspots: [
      {
        id: "inside-back-office",
        position: [2, -0.6, -0.25],
        type: "navigate",
        target: 16,
      },
      {
        id: "inside-back-office",
        position: [0.9, -0.75, 1.5],
        type: "navigate",
        target: 15,
      },
    ],
  },
  {
    id: 15,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Back-Office.mp4",
    title: "Business Workspace",
    rotation: [15, -30, 0],
    next: 16,
    hotspots: [
      {
        id: "center-of-office",
        position: [-0.15, -1.1, 3],
        iconRotation: 75,
        type: "navigate",
        target: 16,
      }
    ],
  },
  
  {
    id: 16,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Center-Of-Facility.mp4",
    title: "H.I.V.E.",
    rotation: [10, 40, 0],
    next: 17,
    hotspots: [
      {
        id: "inside-enlightment-room",
        position: [-0.75, -1, 3],
        type: "navigate",
        target: 13,
      },
      {
        id: "towards-live-demo",
        position: [-2, -2.2, -3],
        type: "navigate",
        target: 17,
      },
      {
        id: "go-back-workstation2",
        position: [-10, -2, 0.2],
        type: "navigate",
        target: 6,
      },
      {
        id: "towards-branding-place",
        position: [0.45, -0.95, -4],
        type: "navigate",
        target: 20,
      },
       {
        id: "old-finance",
        position: [2.55, -1.25, 2],
        type: "navigate",
        target: 18,
      },
    ],
  },
  {
    id: 17,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Running-Demo.mp4",
    title: "Robot Zone",
    rotation: [10, 90, 0],
    next: 18,
    hotspots: [
      {
        id: "towards-old-finance-place",
        position: [2, -1, 3.8],
        type: "navigate",
        target: 18,
      },
      
      {
        id: "to-old-branding-place",
        position: [1.75, -1, -3.1],
        type: "navigate",
        target: 20,
      },
      {
        id: "towards-old-finance-place",
        position: [-0.45, -1, 3.8],
        type: "navigate",
        target: 13,
      },
    ],
  },
  {
    id: 18,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Old-Finance-Place.mp4",
    title: "Finance Workspace",
    rotation: [10, 120, 20],
    next: 19,
    hotspots: [
      {
        id: "current-branding-place",
        position: [0.1, -1.12, -2.1],
        type: "navigate",
        target: 19,
      },
      
      {
        id: "go-to-the-center-of-office",
        position: [-3, -0.9, -0.3],
        type: "navigate",
        target: 23,
      },
      
    ],
  },
  {
    id: 19,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Hr-Workplace.mp4",
    title: "HR Workspace",
    rotation: [10, 90, 0],
    next: 20,
    hotspots: [
      {
        id: "towards-old-branding",
        position: [-0.4, -0.7, -2],
        type: "navigate",
        target: 20,
      },
      {
        id: "towards-old-branding",
        position: [-0.05, -1, 3.5],
        iconRotation: 50,
        type: "navigate",
        target: 18,
      },
    ],
  },
  {
    id: 20,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Old-Branding-Place-1.mp4",
    title: "Branding and Marketing Workspace",
    rotation: [0, 30, 0],
    next: 21,
    hotspots: [
      {
        id: "inside-back-office",
        position: [0.25, -0.9, -2],
        type: "navigate",
        target: 21,
      },
      {
        id: "inside-back-office",
        position: [0.75, -0.75, 2],
        type: "navigate",
        target: 19,
      },
      {
        id: "inside-back-office",
        position:  [-2, -0.5, 0.05],
        iconRotation: -5,
        type: "navigate",
        target: 22,
      },
    ],
  },
  {
    id: 21,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Old-Branding-Place.mp4",
    title: "Branding and Marketing Workspace",
    rotation: [15, 90, 0],
    next: 22,
    hotspots: [
      {
        id: "inside-back-office",
        position: [-2, -1.75, 3.5],
        iconRotation: 90,
        type: "navigate",
        target: 20,
      },
    ],
  },
  {
    id: 22,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Left-Side-End.mp4",
    title: "Robot Zone",
    rotation: [10, 110, 0],
    next: 23,
    hotspots: [
      {
        id: "return-to-live-demo",
        position: [-0.25, -0.525, 2],
        type: "navigate",
        iconRotation: 20,
        target: 17,
      },
      {
        id: "return-to-left",
        position: [-0.5, -0.8, -2.4],
        type: "navigate",
        target: 4,
      },
      {
        id: "return-to-left",
        position: [-2, -0.5, 0.65],
        type: "navigate",
        target: 23,
      },
    ],
  },
  {
    id: 23,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Exact-Center-Of-Facility.mp4",
    title: "H.I.V.E.",
    rotation: [10, 25, 0],
    next: 6,
    hotspots: [
      {
        id: "back-to-workstation-2",
        position: [3, -0.5, 0],
        type: "navigate",
        target: 6,
      },
      {
        id: "infront-of-epiphony",
        position: [0.1, -0.8, -3],
        type: "navigate",
        target: 13,
      },
      {
        id: "to-old-finance-place",
        position: [-3, -0.8, -0.9],
        type: "navigate",
        target: 18,
      },
      {
        id: "to-old-finance-place",
        position: [-2, -1.5, 0.05],
        type: "navigate",
        target: 16,
      },
    ],
  },
  {
    id: 24,
    image: "https://pub-f2c8c7a9bc4a4723915389d2e8298c72.r2.dev/Final-facility-tour-assets/Left-Entry.mp4",
    title: "Robot Zone",
    rotation: [0, 20, 0],
    next: 5,
    hotspots: [
      {
        id: "towards-center-of-the-office",
        position: [-0.5, -0.75, 2.5],
        type: "navigate",
        target: 22,
      },
      {
        id: "inside-the-thought",
        position: [0.53, -1.1, -2.1],
        iconRotation: 15,
        type: "navigate",
        target: 5,
      },
      {
        id: "towards-right-side",
        position: [-1.9, -1.75, -3],
        iconRotation: 5,
        type: "navigate",
        target: 4,
      },
    ],
  },
];